import { SET_FILTER_DATA, SET_FILTER_JOBID, SHOW_DUPLICATE, SHOW_DUPLICATE_RESET } from "../types"

/****************Ragnar Lodbrok****************/

//set filters

export const setFilterData = (data) => ({
	type: SET_FILTER_DATA,
	payload: data,
})

//set filter jobid

export const setFilterJobId = (data) => ({
	type: SET_FILTER_JOBID,
	payload: data,
})

export const showDuplicateAction = (data) => ({
	type: SHOW_DUPLICATE,
	payload: data,
})

export const showDuplicateActionReset = () => ({
	type: SHOW_DUPLICATE_RESET,
})
